// extracted by mini-css-extract-plugin
export default {"App":"App_App__KMLiY","App-logo":"App_App-logo__59+F8","App-logo-spin":"App_App-logo-spin__Hs8AF","App-header":"App_App-header__TTyoY","App-link":"App_App-link__Macm2"};